import React from 'react';
import { Navigate } from 'react-router';
import { NavLink } from 'react-router-dom';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';
import Stuff from "./Stuff";
import ImportExcel from "./ImportExcel";

export default class Stuffs extends Base {
    constructor(props) {
        super(props);
        this.state = {
            controllerName: 'stuff',
            initType: this.isNull(props.InitType) ? 0 : props.InitType,
            data: null,
            loading: true,
            page: 1,
            per_page: 30,
            phrase: '',
            menuId: 0
        };
        this.state.filters = {
            taxNumber: '',
            categoryName: '',
            unitName: '',
            type: this.state.initType
        }
        this.setMenuId();
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.refreshData();
    }
    componentWillReceiveProps(props) {
        var initType = this.isNull(props.InitType) ? 0 : props.InitType;
        if (initType === this.state.initType) return;

        this.state.initType = initType;
        this.state.filters.type = this.state.initType;
        this.setMenuId();
        this.refreshData();
    }
    setMenuId() {
        if (this.state.initType === 0) this.state.menuId = 17;
        if (this.state.initType === 1) this.state.menuId = 17;
        if (this.state.initType === 2) this.state.menuId = 17;
        if (this.state.initType === 3) this.state.menuId = 17;
        if (this.state.initType === 4) this.state.menuId = 17;
        if (this.state.initType === 5) this.state.menuId = 17;
        if (this.state.initType === 6) this.state.menuId = 17;
        if (this.state.initType === 7) this.state.menuId = 230;
        if (this.state.initType === 8) this.state.menuId = 231;
        if (this.state.initType === 9) this.state.menuId = 240;
    }
    onEdit(id) {
        this.removeKeyDown();
        this.showComponents({ component: <Stuff Caller={this} Id={id} InitType={this.state.initType} /> });
    }
    onAdd() {
        this.removeKeyDown();
        this.showComponents({ component: <Stuff Caller={this} InitType={this.state.initType} /> });
    }
    onImport() {
        this.removeKeyDown();
        this.showComponents({ component: <ImportExcel Caller={this} Type={3} CompanyId={this.state.data.global.company.id} /> });
    }

    getCaption() {
        if (this.state.initType === 0) return "کالا و خدمت";
        if (this.state.initType === 1) return "کالا";
        if (this.state.initType === 2) return "خدمت";
        if (this.state.initType === 3) return "محصول";
        if (this.state.initType === 4) return "ماده اولیه";
        if (this.state.initType === 5) return "دارایی ثابت";
        if (this.state.initType === 6) return "ابزار مصرفی";
        if (this.state.initType === 7) return "دام";
        if (this.state.initType === 8) return "دارو";
        if (this.state.initType === 9) return "نوع دام";
        return "";
    }
    getCaptions() {
        if (this.state.initType === 0) return "کالاها و خدمات";
        if (this.state.initType === 1) return "کالاها";
        if (this.state.initType === 2) return "خدمات";
        if (this.state.initType === 3) return "محصولات";
        if (this.state.initType === 4) return "مواد اولیه";
        if (this.state.initType === 5) return "دارایی های ثابت";
        if (this.state.initType === 6) return "ابزارهای مصرفی";
        if (this.state.initType === 7) return "دام ها";
        if (this.state.initType === 8) return "دارو ها";
        if (this.state.initType === 9) return "انواع دام";
        return "";
    }
    renderForm() {
        if (!this.hasPermission(this.state.menuId)) return this.renderPermissionDenied();
        return <div>
            <div className="nk-content-body">
                <div className="nk-block-head nk-block-head-sm">
                    <div className="nk-block-between">
                        <div className="nk-block-head-content">
                            <h3 className="nk-block-title page-title">فهرست {this.getCaptions()}</h3>
                            <div className="nk-block-des text-soft">
                                <p>{this.money(this.state.data.recordsCount)} {this.getCaption()} یافت شد</p>
                            </div>
                        </div>
                        <div className="nk-block-head-content">
                            <div className="toggle-wrap nk-block-tools-toggle">
                                <a href="#" className="btn btn-icon btn-trigger toggle-expand me-n1" data-target="pageMenu"><em className="icon ni ni-menu-alt-r"></em></a>
                                <div className="toggle-expand-content" data-content="pageMenu">
                                    <ul className="nk-block-tools g-3">
                                        <li>
                                            <a className="hand btn btn-primary" onClick={e => this.onAdd()}><em className="icon ni ni-plus"></em><span>ایجاد</span></a>
                                        </li>
                                        <li>
                                            <a onClick={e => this.onImport()} className="hand btn btn-success"><em className="icon ni ni-file-xls"></em><span>ورود اکسل</span></a>
                                        </li>
                                        <li>
                                            <NavLink to="/units/" className="hand btn btn-warning"><em className="icon ni ni-list"></em><span>واحدهای سنجش</span></NavLink>
                                        </li>
                                        <li>
                                            {this.state.initType !== 9 && this.state.initType !== 7 && <NavLink to="/stuffcategories/" className="hand btn btn-warning"><em className="icon ni ni-list"></em><span>گروه ها</span></NavLink>}
                                            {this.state.initType === 7 && <NavLink to="/animalcategories/" className="hand btn btn-warning"><em className="icon ni ni-list"></em><span>گونه های دام</span></NavLink>}
                                            {this.state.initType === 7 && <NavLink to="/breeds/" className="hand btn btn-warning"><em className="icon ni ni-list"></em><span>انواع نژاد</span></NavLink>}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="nk-block">
                    <div className="card card-bordered card-stretch">
                        <div className="card-inner-group">
                            <div className="card-inner position-relative card-tools-toggle">
                                <div className="card-title-group">
                                    <form className="card-tools" mthod="post" onSubmit={e => this.refreshData(e)}>
                                        <div className="form-inline flex-nowrap gx-3">
                                            <div className="form-wrap">
                                                <input type="text" defaultValue={this.state.phrase} onChange={e => this.state.phrase = e.target.value} placeholder="نام" className="form-control" />
                                            </div>
                                            {this.state.initType !== 7 && <div className="form-wrap">
                                                <input type="text" defaultValue={this.state.filters.taxNumber} onChange={e => this.state.filters.taxNumber = e.target.value} placeholder="شماره مالیاتی" className="form-control" />
                                            </div>}
                                            <div className="form-wrap">
                                                <input type="text" defaultValue={this.state.filters.categoryName} onChange={e => this.state.filters.categoryName = e.target.value} placeholder={this.state.initType !== 7 ? "عنوان گروه" : "نوع"} className="form-control" />
                                            </div>
                                            <div className="form-wrap">
                                                <input type="text" defaultValue={this.state.filters.unitName} onChange={e => this.state.filters.unitName = e.target.value} placeholder="عنوان واحد سنجش" className="form-control" />
                                            </div>
                                            {this.state.initType !== 7 && <div className="form-wrap">
                                                <select autocomplete="off" defaultValue={this.state.filters.type} onChange={e => this.state.filters.type = parseInt(e.target.value)} className="form-control input-sm">
                                                    <option value="0">همه نوع</option>
                                                    <option value="1">کالا</option>
                                                    <option value="2">خدمت</option>
                                                    <option value="3">محصول</option>
                                                    <option value="4">ماده اولیه</option>
                                                    <option value="5">دارایی ثابت</option>
                                                    <option value="6">ابزار آلات مصرفی</option>
                                                </select>
                                            </div>}
                                            <div className="btn-wrap">
                                                <span className="d-none d-md-block"><button onClick={e => this.refreshData(e)} type="submit" className="btn btn-dim btn-outline-light hand"><em className="icon ni ni-search"></em> جستجو</button></span>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>

                            {this.state.data.recordsCount <= 0 ?
                                <div className="card-inner-group">
                                    <div className="example-alert">
                                        <div className="alert alert-pro alert-warning">
                                            <div className="alert-text">
                                                <h6>توجه</h6>
                                                <p>هیچ {this.getCaption()} یافت نشد</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                :
                                <div className="card-inner p-0">
                                    <div className="nk-tb-list nk-tb-ulist">
                                        <div className="nk-tb-item nk-tb-head">
                                            <div className="nk-tb-col text-center"><span className="sub-text">{this.state.initType !== 7 ? "عنوان" : "شماره گوشواره" }</span></div>
                                            {this.state.initType !== 7 && <div className="nk-tb-col text-center"><span className="sub-text">عنوان 2</span></div>}
                                            <div className="nk-tb-col text-center"><span className="sub-text">کد</span></div>
                                            {this.state.initType !== 7 && <div className="nk-tb-col text-center"><span className="sub-text">نوع</span></div>}
                                            {this.state.initType === 7 && <div className="nk-tb-col text-center"><span className="sub-text">نوع دام</span></div>}
                                            <div className="nk-tb-col text-center"><span className="sub-text">{this.state.initType !== 7 ? "گروه" : "گونه" }</span></div>
                                            {this.state.initType !== 7 && <div className="nk-tb-col text-center"><span className="sub-text">شماره مالیاتی</span></div>}
                                            <div className="nk-tb-col text-center"><span className="sub-text">واحد اصلی</span></div>
                                            {this.state.initType !== 7 && this.state.data.global.company.stuffSubUnitEnable === 2 && <div className="nk-tb-col text-center"><span className="sub-text">واحد فرعی</span></div>}
											{this.state.initType !== 7 && <div className="nk-tb-col text-center"><span className="sub-text">نرخ مالیات</span></div>}
											{this.state.initType !== 7 && <div className="nk-tb-col text-center"><span className="sub-text">قیمت واحد</span></div>}
                                            <div className="nk-tb-col text-end"><span className="sub-text">عملیات</span></div>
                                        </div>
                                        {this.state.data.records.map((record, index) =>
                                            <div className="nk-tb-item">
                                                <div className="nk-tb-col">
                                                    <span className="onlyMobile">{this.state.initType !== 7 ? "عنوان" : "شماره گوشواره" }: </span>
                                                    <span className="sub-text text-center">
                                                        <a className="text-primary txt-bold hand" onClick={e => this.onEdit(record.id)} title="مشاهده و ویرایش">
                                                            {record.name}
                                                        </a>
                                                    </span>
                                                </div>
                                                {this.state.initType !== 7 && <div className="nk-tb-col">
                                                    <span className="onlyMobile">عنوان2: </span>
                                                    <span className="sub-text text-center">{record.name2}</span>
                                                </div>}
                                                <div className="nk-tb-col">
                                                    <span className="onlyMobile">کد: </span>
                                                    <span className="sub-text text-center">{record.code}</span>
                                                </div>
                                                {this.state.initType !== 7 && <div className="nk-tb-col">
                                                    <span className="onlyMobile">نوع: </span>
                                                    <span className="sub-text text-center">{record.typeString}</span>
                                                </div>}
                                                {this.state.initType === 7 && <div className="nk-tb-col">
                                                    <span className="onlyMobile">نوع دام: </span>
                                                    <span className="sub-text text-center">{record.parentName}</span>
                                                </div>}
                                                <div className="nk-tb-col">
                                                    <span className="onlyMobile">{this.state.initType !== 7 ? "گروه:" : "گونه:"} </span>
                                                    <span className="sub-text text-center">{record.groupName}</span>
                                                </div>
                                                {this.state.initType !== 7 && <div className="nk-tb-col">
                                                    <span className="onlyMobile">شماره مالیاتی: </span>
                                                    <span className="sub-text text-center">{record.taxNumber}</span>
										</div>}
                                                <div className="nk-tb-col">
                                                    <span className="onlyMobile">واحد اصلی: </span>
                                                    <span className="sub-text text-center">{record.unitName}</span>
                                                </div>
                                                {this.state.initType !== 7 && this.state.data.global.company.stuffSubUnitEnable === 2 && <div className="nk-tb-col">
                                                    <span className="onlyMobile">واحد فرعی: </span>
                                                    <span className="sub-text text-center">{record.modulusUnitName}/{record.modulusUnitRate}</span>
                                                </div>}
                                                {this.state.initType !== 7 && <div className="nk-tb-col">
                                                    <span className="onlyMobile">نرخ مالیات: </span>
                                                    <span className="sub-text text-center">{record.taxRate}</span>
                                                </div>}
                                                {this.state.initType !== 7 && <div className="nk-tb-col">
                                                    <span className="onlyMobile">قیمت واحد: </span>
                                                    <span className="sub-text text-center">{record.price}</span>
										</div>}
                                                <div className="nk-tb-col text-end">
                                                    <a className="hand text-danger mx-1" onClick={e => this.confirmRemove(record.id)} data-bs-toggle="modal" data-bs-target="#modalConfirmRemove" title="حذف">
                                                        <i className="icon ni ni-cross-fill-c"></i>
                                                    </a>
                                                    <a className="hand text-primary mx-1" onClick={e => this.onEdit(record.id)} title="ویرایش">
                                                        <i className="icon ni ni-pen"></i>
                                                    </a>
                                                    {record.code > 0 && <NavLink className="hand text-warning mx-1" to={"/report/transaction/2/" + record.code + "/"} title="مشاهده تراکنش های حساب">
                                                        <i className="icon ni ni-file-docs"></i>
                                                    </NavLink>}
                                                    <NavLink className="hand text-warning mx-1" to={"/stuff/cardex/?stuffId=" + record.id } title="کارتکس کالا">
                                                        <i className="icon ni ni-box"></i>
                                                    </NavLink>                                                    
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            }
                            {this.createPaging()}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                <Header data={this.state.data} />,

                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.isEmpty(this.state.data.global.companies) ? this.renderNoCompanyRegister() : this.renderForm()}
                        </div>
                    </div>
                </div>,
                ,
                this.renderPopupComponent(),
                <Footer />
            ];

        return contents;
    }
}